import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { AuthBackend } from './auth.backend';

@NgModule({
  providers: [AuthService, AuthBackend],
})
export class AuthModule {}
